import {
  Box,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  SwipeableDrawer,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { ContainerSizeImage } from "../design-system/Image";
import { useMenuIdFromURL } from "../hooks/menuIdFromURL";
import { useAuthentication } from "../auth-provider/AuthProvider";
import OrderItLogo from "./img/orderit-logo.png";
import MenuIcon from "@mui/icons-material/Menu";
import GridViewIcon from "@mui/icons-material/GridView";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import EditNoteIcon from "@mui/icons-material/EditNote";
import KitchenIcon from "@mui/icons-material/Kitchen";
import BarChartIcon from "@mui/icons-material/BarChart";
import InventoryIcon from "@mui/icons-material/Inventory";
import QueueIcon from "@mui/icons-material/Queue";
import SettingsIcon from "@mui/icons-material/Settings";
import QrCodeIcon from "@mui/icons-material/QrCode";
import HistoryIcon from "@mui/icons-material/History";
import LogoutIcon from "@mui/icons-material/Logout";
import { NavLink } from "./NavLink";

export const NavigationDrawer = () => {
  const [isDrawerShowing, setIsDrawerShowing] = useState<boolean>(false);
  const menuId = useMenuIdFromURL();
  const { isLoggedIn, logout } = useAuthentication();
  const history = useHistory();

  const handleLogout = () => {
    setIsDrawerShowing(false);
    logout();
    history.push("/login");
  };

  return (
    <Box>
      <IconButton
        edge="start"
        aria-label="drawer-open"
        data-testid="test-id-open-drawer"
        onClick={() => setIsDrawerShowing(true)}
        sx={{ color: "rgb(19, 63, 103)" }}
      >
        <MenuIcon fontSize="large" />
      </IconButton>

      <SwipeableDrawer
        open={isDrawerShowing}
        onClose={() => setIsDrawerShowing(false)}
        onOpen={() => setIsDrawerShowing(true)}
        PaperProps={{
          sx: { width: 240, display: "flex", flexDirection: "column" },
        }}
      >
        <Box
          px={2}
          py={1.5}
          component={Link}
          to="/"
          data-testid="logo"
          sx={{ display: "block" }}
        >
          <ContainerSizeImage src={OrderItLogo} />
        </Box>

        <Divider />

        <List sx={{ px: 0.5, pt: 1, flex: 1 }}>
          <NavLink
            to="/dashboard/menu"
            title="My Menus"
            dataTestId="test-id-menu-list"
            icon={<GridViewIcon fontSize="small" />}
          />

          {menuId && (
            <>
              <Box px={1.5} pt={1.5} pb={0.5}>
                <Typography
                  variant="caption"
                  color="text.disabled"
                  fontWeight={600}
                  letterSpacing={0.8}
                >
                  THIS MENU
                </Typography>
              </Box>

              <NavLink
                to={`/dashboard/menu/${menuId}/orders`}
                title="Orders"
                dataTestId="test-id-order-nav-button"
                icon={<ReceiptLongIcon fontSize="small" />}
              />
              <NavLink
                to={`/dashboard/menu/${menuId}/orders/history`}
                title="Order History"
                dataTestId="test-id-order-history-nav-button"
                icon={<HistoryIcon fontSize="small" />}
              />
              <NavLink
                to={`/dashboard/menu/${menuId}/update`}
                title="Edit Menu"
                dataTestId="test-id-update-menu-nav-button"
                icon={<EditNoteIcon fontSize="small" />}
              />
              <NavLink
                to={`/dashboard/menu/${menuId}/kds`}
                title="Kitchen Display"
                dataTestId="test-id-kds-nav-button"
                icon={<KitchenIcon fontSize="small" />}
              />
              <NavLink
                to={`/dashboard/menu/${menuId}/reports`}
                title="Reports"
                dataTestId="test-id-reports-nav-button"
                icon={<BarChartIcon fontSize="small" />}
              />
              <NavLink
                to={`/dashboard/menu/${menuId}/inventory`}
                title="Inventory"
                dataTestId="test-id-inventory-nav-button"
                icon={<InventoryIcon fontSize="small" />}
              />
              <NavLink
                to={`/dashboard/menu/${menuId}/queueing-display`}
                title="Queue Display"
                dataTestId="test-id-queueing-display-nav-button"
                icon={<QueueIcon fontSize="small" />}
              />
              <NavLink
                to={`/dashboard/menu/${menuId}/settings`}
                title="Settings"
                dataTestId="test-id-settings-nav-button"
                icon={<SettingsIcon fontSize="small" />}
              />
              <NavLink
                to={`/dashboard/menu/${menuId}/qr-generation`}
                title="QR Codes"
                dataTestId="test-id-qr-generation-nav-button"
                icon={<QrCodeIcon fontSize="small" />}
              />
            </>
          )}
        </List>

        <Divider />

        {isLoggedIn && (
          <List sx={{ px: 0.5, pb: 1 }}>
            <ListItem disablePadding>
              <ListItemButton
                onClick={handleLogout}
                sx={{ borderRadius: 1, mx: 0.5 }}
              >
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <LogoutIcon fontSize="small" color="error" />
                </ListItemIcon>
                <ListItemText
                  primary="Log out"
                  primaryTypographyProps={{ fontSize: 14, color: "error.main" }}
                />
              </ListItemButton>
            </ListItem>
          </List>
        )}
      </SwipeableDrawer>
    </Box>
  );
};
